export default __webpack_public_path__ + "static/media/index_empty.18e175b9.svg";